import { Component, OnInit } from "@angular/core";
import { HeaderService } from "../../services/header.service";

@Component({
  selector: "app-thanks-page",
  templateUrl: "./thanks-page.component.html",
  styleUrls: ["./thanks-page.component.css"],
})
export class ThanksPageComponent implements OnInit {
  public colorSecondary;
  isHeaderCollapsed = false;

  constructor(private headerService: HeaderService) {
    this.headerService.collapsed$.subscribe((collapsed) => {
      this.isHeaderCollapsed = collapsed;
    });
  }

  ngOnInit() {
    this.colorSecondary = sessionStorage.colorSecondary;
    sessionStorage.removeItem("wasInTheCall");
    sessionStorage.clear();
  }
}
